import React from 'react';

export const LoadingScreen = ({ logoUrl, showLogo, title, subtitle, fadeOut }) => (
  <div data-testid="loading-screen" dir="rtl"
    className={`fixed inset-0 z-[200] flex items-center justify-center overflow-hidden bg-[#FBFAF7] transition-[opacity,transform] duration-700 ${fadeOut ? 'opacity-0 scale-[1.02]' : 'opacity-100'}`}
    style={{ fontFamily: 'Cairo, Tajawal, sans-serif' }}>
    <div className="absolute inset-0 opacity-[0.5]" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(15,23,42,0.07) 1px, transparent 0)', backgroundSize: '26px 26px' }} />
    <div className="absolute w-[620px] h-[620px] rounded-full bg-orange-200/40 blur-[110px] ls-breathe" />
    <div className="absolute top-0 inset-x-0 h-1 bg-gradient-to-l from-orange-500 via-amber-400 to-orange-600" />

    <div className="relative flex flex-col items-center">
      {showLogo && (
        <div className="relative w-44 h-44 flex items-center justify-center ls-rise">
          <svg className="absolute inset-0 w-full h-full ls-spin" viewBox="0 0 100 100">
            <defs>
              <linearGradient id="lsg" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#F97316" />
                <stop offset="100%" stopColor="#FBBF24" stopOpacity="0" />
              </linearGradient>
            </defs>
            <circle cx="50" cy="50" r="47" fill="none" stroke="#F1EDE6" strokeWidth="1.5" />
            <circle cx="50" cy="50" r="47" fill="none" stroke="url(#lsg)" strokeWidth="2.5" strokeLinecap="round" strokeDasharray="110 300" />
          </svg>
          <div className="absolute inset-4 rounded-full bg-white shadow-[0_20px_50px_-15px_rgba(249,115,22,0.35)]" />
          <img src={logoUrl} alt="" className="relative w-28 h-28 object-contain" />
        </div>
      )}
      <h1 className="mt-8 text-3xl sm:text-4xl font-black text-slate-900 ls-rise" style={{ animationDelay: '120ms' }}>{title}</h1>
      {subtitle && <p className="mt-2 text-sm sm:text-base font-semibold text-slate-500 ls-rise" style={{ animationDelay: '220ms' }}>{subtitle}</p>}
      <div className="mt-8 w-44 h-1.5 rounded-full bg-orange-200/70 overflow-hidden ls-rise" style={{ animationDelay: '320ms' }}>
        <div className="h-full w-1/3 rounded-full bg-gradient-to-l from-orange-500 to-amber-400 ls-bar" />
      </div>
    </div>
    <div className="absolute bottom-8 text-[11px] tracking-[0.3em] text-slate-400 font-semibold" dir="ltr">EST. 1974</div>
  </div>
);
